import { useState } from "react";
import { ImageOff } from "lucide-react";
import { resolveImage } from "@/lib/zafaraApi";

/**
 * <ProductImage /> — displays a Zafara-branded fallback when the source
 * image returns 404/network error, instead of showing the broken-image
 * icon + alt text (which looks unprofessional).
 */
export const ProductImage = ({ src, alt, className = "" }) => {
  const [broken, setBroken] = useState(false);
  const resolved = src ? resolveImage(src) : null;
  if (!resolved || broken) {
    return (
      <div className={`flex flex-col items-center justify-center bg-gradient-to-br from-[#F7F1E1] to-[#E7F3EC] ${className}`}>
        <ImageOff className="h-8 w-8 text-[#0E7A3B]/40" strokeWidth={1.5} />
        <span className="mt-2 font-utility text-[10px] uppercase tracking-widest text-[#16241B]/40">
          Image bientôt
        </span>
      </div>
    );
  }
  return (
    <img
      src={resolved}
      alt={alt || ""}
      className={className}
      loading="lazy"
      onError={() => setBroken(true)}
    />
  );
};
